export const servicesSolutions = [
  {
    icon: 'code-slash',
    title: 'Frontend Development',
    description: 'Development of scalable web applications using Vue.js, React, TypeScript and modern Front-end architecture.'
  },
  {
    icon: 'layers',
    title: 'Frontend Architecture',
    description: 'Project organization, scalable architecture, monorepos, reusable components and engineering best practices.'
  },
  {
    icon: 'grid',
    title: 'Design Systems',
    description: 'Creation and evolution of Design Systems, reusable component libraries, Storybook documentation and design tokens.'
  },
  {
    icon: 'chat-square-text',
    title: 'Technical Consulting',
    description: 'Code review, architecture review, performance analysis and technical guidance for development teams.'
  },
  {
    icon: 'palette',
    title: 'UX & Product',
    description: 'Wireframes, usability improvements, user flow analysis and rapid prototyping for digital products.'
  },
  {
    icon: 'universal-access-circle',
    title: 'Accessibility',
    description: 'Accessibility audits, WCAG compliance, inclusive interfaces and accessibility implementation.'
  },
  {
    icon: 'speedometer',
    title: 'Performance Optimization',
    description: 'Application optimization, Core Web Vitals improvements, lazy loading, rendering optimization and bundle reduction.'
  },
  {
    icon: 'tools',
    title: 'Code Rescue',
    description: 'Refactoring legacy applications, bug fixing, modernization and migration to modern Front-end technologies.'
  },
  {
    icon: 'phone',
    title: 'Responsive Interfaces',
    description: 'Responsive interfaces optimized for desktop, tablet and mobile with focus on usability and performance.'
  }
]
